import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import s from './index.module.scss';

export const Tabs = ({ links  }) => {
  return (
    <div className={s.wrapper}>
      <div className={s.tabs}>
        {links.map(tab => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={({ isActive }) =>
              classnames(s.link, isActive && s.link_active, 'f-article-regular')
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};
